module.exports = __webpack_public_path__ + "static/media/not_set_2.3da29447.svg";